import TemplateComponentController from '../template_component_controller'

export default class extends TemplateComponentController {
  protected logPrefix = '[CreditCardFormSetup]'

  // Setup forms only save a card — no charge is attempted, so the payment
  // wording from the base controller would be misleading here.
  protected get submissionErrorMessage(): string {
    return 'We could not save your card. Please try again, or contact support if the problem continues.'
  }
}
